import { Box, Tooltip, Chip } from "@mui/joy";
import { Info as InfoIcon } from "lucide-react";

import { IconButton } from "../../../../../../shared";

/**
 * Info cell renderer - opens edit form for labor rate
 */
export function Info(props: any) {
    const { data, onEdit } = props;

    const handleClick = () => {
        if (onEdit && data) {
            onEdit(data);
        }
    };

    return (
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} height={"100%"}>
            <Tooltip title="View details" placement="top">
                <IconButton
                    size="sm"
                    variant="soft"
                    color="primary"
                    onClick={handleClick}
                    sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        "--IconButton-size": "32px",
                    }}
                >
                    <InfoIcon size={16} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}

/**
 * Status chip component with color coding
 */
export function StatusChip({ isActive }: { isActive: boolean }) {
    return (
        <Chip
            variant="soft"
            color={isActive ? "success" : "neutral"}
            size="md"
            sx={{ borderRadius: "4px", border: "1px solid", borderColor: "divider" }}
        >
            {isActive ? "Active" : "Inactive"}
        </Chip>
    );
}

/**
 * Status cell renderer
 */
export function StatusCellRenderer(props: any) {
    const { data } = props;
    return <StatusChip isActive={data.IsActive} />;
}
